import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import StyledContentText from '../StyledContentText';

import styles from './styles.module.scss';

const StyledContentColumns = ({ items }) => {
	const filterItems = items.reduce((memo, value) => {
		if (
			value.type === 'column' &&
			value.content.length &&
			value.content[0].type === 'text'
		) {
			return [...memo, value.content[0].text];
		}

		return memo;
	}, []);
	const styledContentColumnsCx = cx(styles.StyledContentColumns, {
		[styles.StyledContentColumns__single]: filterItems.length === 1
	});

	return filterItems.length ? (
		<div className={styledContentColumnsCx}>
			{filterItems.map((item, index) => (
				<div
					key={item.substring(0, 30)}
					className={styles.StyledContentColumns_Column}
				>
					<StyledContentText text={item} firstParagraph={index === 0} />
				</div>
			))}
		</div>
	) : null;
};

StyledContentColumns.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			content: PropTypes.arrayOf(
				PropTypes.shape({
					text: PropTypes.string,
					type: PropTypes.string
				})
			),
			type: PropTypes.oneOf(['column'])
		})
	)
};

export default StyledContentColumns;
